import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Row from '../Row';
import Col from '../Col';
import Heading from '../../components/Heading';
import Input from '../../components/Input';
import Textarea from '../../components/Textarea';
import Form from '../../components/Form';
import { Carousel } from 'react-responsive-carousel';
import 'yet-another-react-lightbox/styles.css';
import ReusableLightbox from 'src/components/ReusableLightbox/reusable-lightbox';

class CommonIssuesView extends Component {
  state = {
    showImages: false,
    selectedIndex: null,
    selectedImages: [],
  };

  displayLightboxImages = () => {
    const { showImages, selectedImages, selectedIndex } = this.state;

    // Extract URLs for ReusableLightbox
    const imageUrls = selectedImages.map((attachment) => attachment.url);

    return (
      <ReusableLightbox
        isOpen={showImages}
        onClose={() => this.setState({ showImages: false })}
        images={imageUrls}
        initialIndex={selectedIndex}
        onIndexChange={(index) => this.setState({ selectedIndex: index })}
      />
    );
  };

  render() {
    const { onClose } = this.props;
    const { showImages, selectedIndex } = this.state;
    let issueData = this.props.data;
    let attachments =
      issueData && issueData.attachment ? JSON.parse(issueData.attachment) : [];

    return (
      <Form
        headline={'Common Issue View'}
        onClose={onClose}
        component={
          <>
            <Row mdCenter>
              <Col xs="12" md="6">
                <Heading>Common Issue Details</Heading>
                <Input
                  value={issueData.issueTypeName}
                  label="Issue Type"
                  disabled={true}
                  block
                />
                <Textarea
                  value={issueData.description}
                  label="Description"
                  block
                />
                {attachments && attachments.length > 0 ? (
                  <div
                    className="textarea__label"
                    style={{ display: 'flex', marginBottom: 10 }}
                  >
                    Attachments
                  </div>
                ) : null}
                <Carousel autoPlay>
                  {attachments && attachments.length > 0
                    ? attachments.map((data, i) => {
                        return (
                          <div
                            style={{ backgroundColor: '#fff' }}
                            onClick={() =>
                              this.setState({
                                showImages: true,
                                selectedIndex: i,
                                selectedImages: attachments,
                              })
                            }
                          >
                            <img alt="" src={data.url} />
                          </div>
                        );
                      })
                    : null}
                </Carousel>
              </Col>
            </Row>
            {showImages &&
            showImages === true &&
            attachments &&
            attachments.length === 1
              ? this.displayLightboxImages(selectedIndex, 'single')
              : this.displayLightboxImages(selectedIndex, 'multiple')}
          </>
        }
      />
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CommonIssuesView);
